// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsStressTestAppModule } from './app.module';
bootstrapAppModule(MutualFundsStressTestAppModule);
